<template>
    <Intentar 
        v-if="activarIntentar == true" 
        @accionCerrar="cerrarIntentar"
    />
    <Loader 
       v-if="loader == true"
    />
    <div class="" :class="[ estilo ]">
        <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-5 col-lg-12" >
                <h4 class="animate__animated animate__zoomIn animate__delay-1s">{{p}}</h4>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-7 col-lg-12 respuestas">
                <div class="boton1 butonres animate__animated animate__bounceIn animate__delay-1s" >
                <a @click="guardar('a',link,'isActive1')" class="butonpregun btn btn-default" v-bind:class="{ active: isActive1 }"><span>a</span>{{r1}}</a>
                </div>
                <div class="boton2 butonres animate__animated animate__bounceIn animate__delay-1s">
                <a @click="guardar('b',link,'isActive2')" class="butonpregun btn btn-default" v-bind:class="{ active: isActive2 }"><span>b</span>{{r2}}</a>
                </div>
                <div class="boton3 butonres animate__animated animate__bounceIn animate__delay-1s">
                <a @click="guardar('c',link,'isActive3')" class=" butonpregun btn btn-default" v-bind:class="{ active: isActive3 }"><span>c</span>{{r3}}</a>
                </div>
            </div> 
        </div>
    </div>
</template>
<script>
import Intentar from "@/components/Intentar";
import Loader from "@/components/Loader";
export default {
    name : "Control",
    components:{
        Intentar,
        Loader
    },
    props:{
        p: String,
        link: String,
        estilo: String,
        r1: String,
        r2: String,
        r3: String,
        real: String
    },
    data() {
        return{
            activarIntentar: false,
            loader:false,
            isActive1: false,
            isActive2: false,
            isActive3: false
        }
    },    
    
    methods:{
        
        guardar(e,link,activar){
            activar
            let resp = {
                final: e == this.real? true : false,
                result: e,
                real: this.real
            }
            if (resp.result != resp.real) {
                this.activarIntentar = true;

                if(activar == "isActive1"){
                    this.isActive1 = true
                }
                if(activar == "isActive2"){
                    this.isActive2 = true
                }
                if(activar == "isActive3"){
                    this.isActive3 = true
                }
                
            }else{
                //this.activarIntentar = true
                this.loader = true,
                setTimeout(() => {
                    
                    this.$router.push(link);
                }, 800);
                
                this.isActive = false
                
                
            }
        },
        cerrarIntentar(){
            this.activarIntentar = false;
            this.isActive = false
            this.isActive1 = false
            this.isActive2 = false
            this.isActive3 = false
        }
    }
}
</script>

<style>

</style>